import React, { useState, useEffect, useRef } from "react";
import CameraComponent from '../Component/CameraComponent';
import training from '../utils/training';
import EyePoint from '../utils/EyePoint';
import Calibration, { CalibrationModel } from '../utils/Calibration';
import { setModelCallbacks, getModelSession, isModelLoading } from '../utils/onnx_model';
import './home.css';
import '../Component/buttons/buttons.css';
import Select from '../Component/selector/select';
import Autism from "./test/autism";
import Depression from "./test/depression";
import { useNavigate } from 'react-router-dom'

const Home = () => {
  // 动态适配 vWidth 和 vHeight
  const [vSize, setVSize] = useState({ vWidth: 640, vHeight: 480 });
  const [eyePoint, setEyePoint] = useState([50, 50])
  const [eyeRawData, setEyeRawData] = useState([50, 50])
  const gazerInit = useRef(false)
  const [pointOpacity, setPointOpacity] = useState(0);
  const [faceOpacity, setFaceOpacity] = useState(1);
  const [btColor, setBtColor] = useState('gray');
  const [btMsg, setBtMsg] = useState('初始化...');
  const [modelLoaded, setModelLoaded] = useState(false)
  const [isLoadingModel, setIsLoadingModel] = useState(false)
  const CalibrationRef = useRef(null);
  const CalibrationStateRef = useRef(false);
  const FaceRef = useRef();
  const [faceData, setFaceData] = useState(null);
  const FaceStateRef = useRef();
  const [gameIndex, setGameIndex] = useState(0);

  // var mouse = [0, 0];
  let leftArr = [0, 0, 0, 0, 0]
  let leftIndex = 0
  let topArr = [0, 0, 0, 0, 0]
  let topIndex = 0


  const navigate = useNavigate();
  const ArrLen = 2;
  const addPoint = (pos) => {

    leftArr[leftIndex++] = pos[0]
    topArr[topIndex++] = pos[1]
    if (leftIndex === ArrLen)
      leftIndex = 0
    if (topIndex === ArrLen)
      topIndex = 0
    return [(leftArr[0] + leftArr[1] + leftArr[2]) / ArrLen,
    (topArr[0] + topArr[1] + topArr[2]) / ArrLen]
  };

  const onModelLoadStart = () => {
    console.log('模型开始加载');
    setIsLoadingModel(true);
  }

  useEffect(() => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    console.log(`Window width: ${windowWidth}px, Window height: ${windowHeight}px`)
    return () => {
      console.log('end')
    }
  }, []);

  const selectIndex = (index) => {
    console.log("selectIndex:" + index)
    setGameIndex(index)
    
    // 检查校准状态，如果已校准则直接设置为已加载
    const calibrationStatus = CalibrationModel.getCalibrationStatus();
    if (calibrationStatus.isCalibrated) {
      setModelLoaded(true);
      CalibrationStateRef.current = true;
    }
    
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.webkitRequestFullscreen) { // Safari
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) { // IE11
      document.documentElement.msRequestFullscreen();
    }
  }
  //獲取人臉特徵點
  const getChildFaceInfo =async (dat, state, yaw, pitch) => {
    // console.log("getChildFaceInfo:" + state)
    // console.log('face',hash(dat[0])); // 打印对象的哈希值
    if (state) {
      console.log('eye track:', yaw, pitch);
      yaw = Math.max(Math.min((yaw + 0.5), 1), 0);
      pitch = Math.max(Math.min((pitch + 0.5), 1), 0);
      setEyeRawData([yaw, pitch]);
      FaceRef.current = dat;
      setFaceData(dat[0])
      FaceStateRef.current = true
      
      // 检查校准是否完成
      const calibrationStatus = CalibrationModel.getCalibrationStatus();
      
      if (calibrationStatus.isCalibrated) {
        // 校准已完成，隐藏校准界面并设置为已加载模型状态
        setModelLoaded(true);
        CalibrationStateRef.current = true;
        
        // 使用校准模型转换眼部数据为屏幕坐标
        const screenCoords = CalibrationModel.convertToScreenCoordinates([yaw, pitch]);
        
        if (screenCoords) {
          // 将转换后的坐标传给EyePoint
          setEyePoint([screenCoords.x, screenCoords.y]);
          setPointOpacity(1); // 显示眼神点
        }
        
        setFaceOpacity(0); // 隐藏人脸框
      } else {
        // 校准未完成，继续显示校准界面
        // 在校准过程中，如果人脸检测正常，隐藏人脸框
        if (CalibrationStateRef.current || training.loaded) {
          setFaceOpacity(0);
        } else {
          setFaceOpacity(1);
        }
      }

      setBtColor('green');
      setBtMsg('Calibration');
    } else {
      //人臉位置不合適，暫停並提示
      FaceStateRef.current = false
      // if (CalibrationRef.current != null)
      //   CalibrationRef.current.pause()
      
      // 在校准过程中，如果人脸检测失败，显示人脸框进行引导
      setFaceOpacity(1);
      setPointOpacity(0); // 隐藏眼神点
    }
  }
  const onBackSelect = () => {
    setGameIndex(0)
    // 检查校准状态，如果已校准则保持 modelLoaded 为 true
    const calibrationStatus = CalibrationModel.getCalibrationStatus();
    if (calibrationStatus.isCalibrated) {
      setModelLoaded(true);
      CalibrationStateRef.current = true;
    }
  }
  const calibrationChange = () => {
    CalibrationStateRef.current = true;
  }

  // const checkModelLoaded = () => {
  //   const interval = setInterval(() => {
  //     if (training.loaded) {
  //       console.log("training.loaded has changed to true");
  //       clearInterval(interval); // 停止轮询
  //       setModelLoaded(true)
  //       setInterval(EyeGazer, 100);
  //     }
  //     return interval
  //   }, 500);
  // }

  useEffect(() => {
    const uid = sessionStorage.getItem('uid');
    if (!uid) {
      navigate('/login');
    }
    
    // 设置模型加载回调
    setModelCallbacks(
      (provider) => {
        console.log(`ONNX模型加载完成，后端: ${provider}`);
        setIsLoadingModel(false);
      },
      (error) => {
        console.error('ONNX模型加载失败:', error);
        setIsLoadingModel(false);
      }
    );
    
    // 检查模型是否已经存在或正在加载
    if (isModelLoading()) {
      console.log('模型正在加载中');
      setIsLoadingModel(true);
    } else {
      getModelSession().then(session => {
        if (session) {
          console.log('模型已经加载完成');
          setIsLoadingModel(false);
        }
      }).catch(() => {
        // 模型还未加载，这是正常的
      });
    }
    
    // 检查校准状态，如果已校准则设置为已加载
    const calibrationStatus = CalibrationModel.getCalibrationStatus();
    if (calibrationStatus.isCalibrated) {
      setModelLoaded(true);
      CalibrationStateRef.current = true;
      console.log('组件初始化时发现已存在校准数据，直接设置为已加载状态');
    }
    
    return () => { };
  }, [navigate]);

  useEffect(() => {
    function updateVSize() {
      const maxVHeight = window.innerHeight / 2 > 480 ? 480 : window.innerHeight / 2;
      let vHeight = maxVHeight;
      let vWidth = vHeight * 4 / 3;
      // 如果宽度超出屏幕宽度，则按宽度适配
      if (vWidth > window.innerWidth) {
        vWidth = window.innerWidth;
        vHeight = vWidth * 3 / 4;
        if (vHeight > maxVHeight) {
          vHeight = maxVHeight;
          vWidth = vHeight * 4 / 3;
        }
      }
      setVSize({ vWidth: Math.round(vWidth), vHeight: Math.round(vHeight) });
    }
    updateVSize();
    window.addEventListener('resize', updateVSize);
    return () => window.removeEventListener('resize', updateVSize);
  }, []);


  return (
    <div className="Home">
      {/* 模型加载指示器 */}
      {isLoadingModel && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          color: 'white'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            border: '8px solid #333',
            borderTop: '8px solid #4CAF50',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '20px'
          }}></div>
          <div style={{
            fontSize: '24px',
            textAlign: 'center'
          }}>
            模型加载中...
          </div>
        </div>
      )}

      <EyePoint eyePoint={eyePoint} opacity={pointOpacity} />
      <CameraComponent drawFace={false} width={vSize.vWidth} height={vSize.vHeight} opacity={gameIndex > 0 ? faceOpacity : 0}
        getFaceFun={getChildFaceInfo} onModelLoadStart={onModelLoadStart} />
      {modelLoaded && gameIndex === 1 ? <Autism eyePoint={eyePoint} onBackSelect={onBackSelect}></Autism> : null}
      {modelLoaded && gameIndex === 2 ? <Depression eyePoint={eyePoint} onBackSelect={onBackSelect}></Depression> : null}

      {gameIndex === 0 ?
        <Select selectIndex={selectIndex} eyePoint={eyePoint} /> : ''
      }

      {gameIndex > 0 && !modelLoaded ?
        <Calibration ref={CalibrationRef} stateChange={calibrationChange} eyeRawData={eyeRawData} btColor={btColor} btMsg={btMsg} /> : ''
      }
    </div>
  );
}

export default Home;
